/** @typedef {import('./Props').default} Props */

import React from 'react';

/** @extends {React.Component<Props>} */
export default class Tabs extends React.Component {
	render() {
		return (
			<li className="">
				<button
					className={this.props.className ?? ''}
					onClick={this.props.onClick}
					type="button"
				>
					<span className="flex items-center gap-2">
						{this.props.children}
					</span>
				</button>
			</li>
		);
	}
}
